import React, { Component } from 'react'
import debounce from 'lodash.debounce'
import { connect } from 'react-redux'
import { merge, pickBy, mapKeys } from 'lodash'
import { A, ColorWay, Icon, Table, Button, Modal } from '@driftt/tide-core-legacy'
import { bindActionCreators } from 'redux'
import { EducationTooltip } from '@driftt/tide-tooltips-legacy'

import { captureException } from 'utils/SentryHelpers'
import { makePlaybooksTableColumns, PlaybookTabStatusOptions, tableStates, sortProperties, sortDirections, defaultSort } from './constants'
import PlaybooksTableToolbar from '../PlaybooksTableToolbar'
import GoogleAnalyticsBanner from '../../GoogleAnalyticsBanner'
import { playbookRowFactory } from '../PlaybooksTableRow'
import { Paginator } from '../Paginator'
import ACCESS from 'utils/Access'
import EnablePlaybookModal from '../EnablePlaybookModal'
import InnerDisableSalesSequenceModal from 'components/playbook/components/DisableSalesSequenceConfirmModal/InnerDisableSalesSequenceModal'
import MarketplaceModalButton from '../MarketplaceModalButton'
import { orgId } from 'app/modules/org/selectors'
import { updateUserProperties } from 'app/modules/user/properties/actions'
import { properties } from 'app/modules/user/properties/selectors'
import { orgLocale } from 'app/modules/embed/selectors'
import { api } from 'app/modules/playbook/api'

import { newConversation } from 'app/Helpers'
import * as PlaybookActions from 'app/modules/playbook/actions'
import * as PlaybookSelectors from 'app/modules/playbook/selectors'
import * as UserSelectors from 'app/modules/user/selectors'
import * as GateSelectors from 'app/modules/gates/selectors'
import * as TrackingActions from 'app/modules/tracking/actions'

import {
  isEmailPlaybook,
  isLeadBotPlaybook,
  isSalesSequencePlaybook,
  isSignaturePlaybook,
  PlaybookReportType,
} from 'app/modules/playbook/constants'

import {
  archivePlaybookById,
  clonePlaybookById,
  deletePlaybookById,
  disablePlaybookById,
  fetchCategoryCount,
  fetchPlaybooks,
  updateStatus,
  clonePlaybookAsLandingPage,
  clonePlaybookAsBot,
} from '../api/playbooks'

import './style.styl'

const DEBOUNCE_RATE = 400

const hasBotSegment = (playbook) => {
  return playbook && playbook.meta && playbook.meta.containsBotGeneratedSegment
}

class PlaybooksTable extends Component {
  constructor(props) {
    super(props)

    const { activeTab } = props
    const selectedStatus = PlaybookTabStatusOptions[activeTab][0].value
    const initialSort = PlaybookTabStatusOptions[activeTab][0].defaultSort || defaultSort

    this.state = {
      playbooks: null,
      playbooksListRequestPending: false,
      playbooksListFetchFailed: false,
      archiveWarning: false,
      searchString: '',
      isCloneLoadingPlaybookIds: [],  // list of playbook IDs for which a clone call is loading
      isDeleteLoadingPlaybookIds: [],  // list of playbook IDs for which a delete call is loading
      isArchiveLoadingPlaybookIds: [],  // list of playbook IDs for which an archive call is loading
      isUnArchiveLoadingPlaybookIds: [],  // list of playbook IDs for which a disable call is loading
      selectedStatus,
      categoryCounts: {},
      tableState: `${activeTab}_${selectedStatus}`.toUpperCase(),
      pagination: { pageSize: 10, page: 0, totalPages: 0 },
      sort: initialSort,
      enablePlaybookModalOpen: false,
      enablePlaybookModalPlaybook: { playbook: { targeting: { audience: null }, priority: 0, actions: [{ action:{ slug: '' }}]}},
      disableSalesSequencePlaybook: null,
      disableSalesSequenceWarning: false,
    }
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.activeTab != nextProps.activeTab) {
      const selectedStatus = PlaybookTabStatusOptions[nextProps.activeTab][0].value
      const initialSort = PlaybookTabStatusOptions[nextProps.activeTab][0].defaultSort || defaultSort
      this.setState({
        selectedStatus,
        tableState: `${nextProps.activeTab}_${selectedStatus}`.toUpperCase(),
        sort: initialSort,
        playbooksListRequestPending: true,
        pagination: { pageSize: this.state.pagination.pageSize, page: 0, totalPages: 0 },
      }, this.getPlaybooks)
    }
  }

  componentWillMount() {
    this.props.actions.fetchPlaybooksByReportType(PlaybookReportType.TALK_TO_YOUR_OUTBOUND_PROSPECTS)
    // TODO: when this is a real network call, only dispatch this if not loaded and not loading
    this.props.actions.fetchPlaybooksByGatedPlan()
    this.refreshTableData()
  }

  onPlaybookStatusToggled = (playbook) => {
    this.props.actions.track('Playbooks Table - Status Toggled', { status: playbook.status, reportType: playbook.reportType })
  }

  trackOutboundPlaybookTooltipInteraction = ({ eventType, ctaInfo = {}}) => {
    // Tracking tooltipShown, tooltipClosed, playbookEnabled, playbookEdited
    switch (eventType) {
      case 'viewed':
        this.props.actions.track('Tooltip Viewed', { subject: 'outbound-playbook-tooltip' })
        break
      case 'dismissed':
        this.props.actions.track('Tooltip Dismissed', { subject: 'outbound-playbook-tooltip' })
        break
      case 'clicked':
        this.props.actions.track('CTA Clicked', { subject: 'outbound-playbook-tooltip', ...ctaInfo })
        break
      default:
        // if it doesn't match an event type, don't fire a tracking event
    }
  }

  // If they've dismissed the default playbook tooltip, haven't dismissed this one, the playbook is an OBPB, it has the default name, and is turned off
  canShowOutboundPlaybookTooltip = (playbook, showDefaultPlaybooksTooltip, hasDismissedOutboundPlaybookTooltip) => {
    return !showDefaultPlaybooksTooltip &&
      !hasDismissedOutboundPlaybookTooltip &&
      playbook.reportType === 'TALK_TO_YOUR_OUTBOUND_PROSPECTS' &&
      playbook.name === 'Greet Prospects You Emailed' &&
      playbook.status === 'DISABLED'
  }

  getCategoryCounts = async () => {
    try {
      const data = await fetchCategoryCount(this.props.onlyMine)
      this.setState({
        categoryCounts: data,
      })
    } catch(err) {
      captureException(err)
    }
  }

  getPlaybooks = () => {
    this.debouncedFetch && this.debouncedFetch.cancel()
    this.debouncedFetch = debounce(this._getPlaybooks, DEBOUNCE_RATE)
    this.debouncedFetch()
  }

  _getPlaybooks = async () => {
    const {
      searchString,
      sort,
      tableState,
      pagination,
    } = this.state

    const playbookPromise = fetchPlaybooks(tableState, searchString, sort, pagination, this.props.onlyMine)
    // assign the latest fetch to `this`
    this.fetchPlaybookPromise = playbookPromise
    try {
      const { playbooks, meta } = await playbookPromise
      // make sure we ignore any fetch that isn't the latest one
      if (playbookPromise !== this.fetchPlaybookPromise) {
        return
      }

      this.setState({
        playbooksListRequestPending: false,
        playbooksListFetchFailed: false,
        playbooks: playbooks,
        pagination: merge(pagination, meta)
      })
    } catch(err) {
      captureException(err)
      this.setState({
        playbooksListRequestPending: false,
        playbooksListFetchFailed: true,
        playbooks: null,
      })
    }
  }

  refreshTableData = async () => {
    this.getCategoryCounts()
    this.setState({ playbooksListRequestPending: true }, this.getPlaybooks)
  }

  updatePlaybookStatus = async playbook => {
    // TODO loading state
    try {
      await updateStatus(playbook)
      this.onPlaybookStatusToggled(playbook)
    } catch(err) {
      captureException(err)
      // TODO: error state
    }
  }

  clonePlaybook = async (playbook) => {
    try {
      const clonedPlaybook = await clonePlaybookById(playbook.id)
      this.checkClonedPlaybook(playbook, clonedPlaybook)
    } catch(err) {
      captureException(err)
    }
  }

  clonePlaybookAsLandingPage = async (playbook) => {
    try {
      const clonedPlaybook = await clonePlaybookAsLandingPage(playbook.id)
      this.checkClonedPlaybook(playbook, clonedPlaybook)
    } catch(err) {
      captureException(err)
    }
  }

  cloneLandingPagePlaybookAsBot = async (playbook) => {
    try {
      const clonedPlaybook = await clonePlaybookAsBot(playbook.id)
      this.checkClonedPlaybook(playbook, clonedPlaybook)
    } catch(err) {
      captureException(err)
    }
  }

  checkClonedPlaybook = (originalPlaybook, clonedPlaybook) => {
    const isNewEditor = isLeadBotPlaybook(originalPlaybook.reportType)

    if (clonedPlaybook.status !== 'error') {
      window.open(`${isNewEditor ? `/playbooks/editor/${clonedPlaybook.id}` : `/playbooks/${clonedPlaybook.id}/edit`}`, '_self')
    } else {
      this.setState({
        cloneFailed: true,
        cloneFailurePlaybook: originalPlaybook
      })
    }
  }

  deletePlaybook = async playbook => {
    try {
      await deletePlaybookById(playbook.id)
    } catch(err) {
      captureException(err)
      // TODO: error state
    }
    this.setState({
      isDeleteLoadingPlaybookIds: this.state.isDeleteLoadingPlaybookIds.filter(pbId => pbId !== playbook.id),
      playbooksListRequestPending: true,
    }, this.refreshTableData)
  }

  archivePlaybook = async playbook => {
    try {
      await archivePlaybookById(playbook.id)
    } catch(err) {
      captureException(err)
    }
    this.setState({
      isArchiveLoadingPlaybookIds: this.state.isArchiveLoadingPlaybookIds.filter(pbId => pbId !== playbook.id),
      playbooksListRequestPending: true,
    }, this.refreshTableData)
  }

  unArchivePlaybook = async playbook => {
    try {
      await disablePlaybookById(playbook.id)
    } catch(err) {
      captureException(err)
      // TODO: error state
    }
    this.setState({
      isUnArchiveLoadingPlaybookIds: this.state.isUnArchiveLoadingPlaybookIds.filter(pbId => pbId !== playbook.id),
      playbooksListRequestPending: true,
    }, this.refreshTableData)
  }

  updatePagination = (newPageSize, newPage, refetch = true) => {
    const {
      pagination: { totalPages, pageSize: oldPageSize, page: oldPage },
    } = this.state

    this.setState({
      pagination: {
        pageSize: isNaN(parseInt(newPageSize)) ? oldPageSize : newPageSize,
        page: isNaN(parseInt(newPage)) ? oldPage : newPage,
        totalPages,
      },
      playbooksListRequestPending: refetch,
    }, refetch ? this.getPlaybooks : undefined)
  }

  getFormattedColumns = () => {
    const { sort, tableState } = this.state
    return makePlaybooksTableColumns(this.onSortChange, tableState)
      .map(column => {
        if (column.value === sort.property) {
          column.sorting = true
          column.direction = sort.dir
        } else {
          column.sorting = false
        }
        return column
      })
  }

  onSortChange = (property, dir) => {
    const getOppositeDirection = dir =>
      dir === sortDirections.ASC ? sortDirections.DESC : sortDirections.ASC

    this.setState({
      sort: { property, dir: getOppositeDirection(dir) },
      playbooksListRequestPending: true,
    }, this.getPlaybooks)
  }

  onSearchChange = (event) => {
    const {
      pagination: { pageSize, totalPages }
    } = this.state
    event.persist()

    const doSearch = () => {
      this.setState({
        searchString: event.target.value,
        playbooksListRequestPending: true,
        pagination: { page: 0, pageSize, totalPages },
      }, this.getPlaybooks)
    }

    this.debouncedSearch && this.debouncedSearch.cancel()
    this.debouncedSearch = debounce(doSearch, DEBOUNCE_RATE)
    this.debouncedSearch()

    !event.target.value && this.debouncedSearch.flush()
  }

  toggleEnablePlaybookModal = (playbookData) => {
    const { enablePlaybookModalOpen } = this.state
    const { playbook } = playbookData
    const { status, reportType } = playbook

    //if its not a chat playbook just flip the switch and don't show the modal
    if (status === 'DISABLED' && !isEmailPlaybook(reportType) && !isSignaturePlaybook(reportType)) {
      this.setState({
        enablePlaybookModalOpen: !enablePlaybookModalOpen,
        enablePlaybookModalPlaybook: playbookData
      })
    } else {
      this.setState({
        enablePlaybookModalPlaybook: playbookData
      }, () => {
        this.closeEnablePlaybookModal()
        this.onPlaybookStatusChange()
      })
    }
  }

  closeEnablePlaybookModal = () => {
    this.setState({
      enablePlaybookModalOpen: false
    })
  }

  dismissOutboundEducationState = () => {
    this.props.actions.updateUserProperties({
      notify: false,
      properties: {
        hasDismissedOutboundPlaybookEducation: true,
      },
    })
  }

  onPlaybookStatusChange = () => {
    //trigger modal here
    const { playbooks, enablePlaybookModalPlaybook } = this.state
    const { playbook } = enablePlaybookModalPlaybook
    const switchStatus = status =>
      status === 'ENABLED' ? 'DISABLED' : 'ENABLED'

    const newStatus = switchStatus(playbook.status)

    enablePlaybookModalPlaybook.playbook.status = switchStatus(playbook.status)

    if (hasBotSegment(playbook) && newStatus === 'DISABLED') {
      this.setState({
        disableWarning: true,
        disableWarningPlaybook: enablePlaybookModalPlaybook
      })
      return
    }

    // Show a custom warning modal if disabling a Sales Sequence playbook.
    if (isSalesSequencePlaybook(playbook.reportType) && newStatus === 'DISABLED') {
      this.setState({
        disableSalesSequencePlaybook: playbook,
        disableSalesSequenceWarning: true,
      })

      return
    }

    this.updatePlaybookStatus(enablePlaybookModalPlaybook.playbook)

    const playbookIndex = playbooks.findIndex(p => p.playbook.id === playbook.id)
    if (playbookIndex > -1) {
      const playbooksWithNewlyModifiedPlaybook = playbooks.slice(0, playbookIndex).concat([enablePlaybookModalPlaybook]).concat(playbooks.slice(playbookIndex + 1))
      this.setState({
        playbooks: playbooksWithNewlyModifiedPlaybook
      })
    }
  }

  onSelectedStatusChange = option => {
    const {
      activeTab
    } = this.props

    const {
      sort,
      pagination: { pageSize },
    } = this.state
    // don't let them sort by priority if they're not in the CHAT_ACTIVE state
    const newTableState = `${activeTab}_${option.value}`.toUpperCase()
    let newSort = sort
    if (newTableState !== tableStates.CHAT_ACTIVE && sort.property === sortProperties.PRIORITY) {
      newSort = defaultSort
    } else if (newTableState === tableStates.CHAT_ACTIVE) {
      newSort = { dir: sortDirections.ASC, property: sortProperties.PRIORITY }
    }

    option && this.setState({
      selectedStatus: option.value,
      playbooksListRequestPending: true,
      tableState: `${activeTab}_${option.value}`.toUpperCase(),
      sort: newSort,
      pagination: { page: 0, pageSize, totalPages: 0 },
    }, this.getPlaybooks)
  }

  onDropdownActionClick = (playbook, action) => {
    const {
      isCloneLoadingPlaybookIds,
      isDeleteLoadingPlaybookIds,
      isArchiveLoadingPlaybookIds,
      isUnArchiveLoadingPlaybookIds,
    } = this.state

    const actions = {
      DELETE: playbook => {
        this.setState({ isDeleteLoadingPlaybookIds: isDeleteLoadingPlaybookIds.concat([playbook.id]) })
        this.deletePlaybook(playbook)
      },
      CLONE: playbook => {
        this.setState({ isCloneLoadingPlaybookIds: isCloneLoadingPlaybookIds.concat([playbook.id]) })
        this.clonePlaybook(playbook)
      },
      CLONE_AS_LANDING_PAGE: playbook => {
        this.setState({ isCloneLoadingPlaybookIds: isCloneLoadingPlaybookIds.concat([playbook.id]) })
        this.clonePlaybookAsLandingPage(playbook)
      },
      CLONE_AS_BOT_PLAYBOOK: playbook => {
        this.setState({ isCloneLoadingPlaybookIds: isCloneLoadingPlaybookIds.concat([playbook.id]) })
        this.cloneLandingPagePlaybookAsBot(playbook)
      },
      ARCHIVE: playbook => {
        this.setState({ isArchiveLoadingPlaybookIds: isArchiveLoadingPlaybookIds.concat([playbook.id]) })

        if (hasBotSegment(playbook)) {
          this.setState({
            archiveWarning: true,
            archiveWarningPlaybook: playbook,
          })
          return
        }

        this.archivePlaybook(playbook)
      },
      UNARCHIVE: playbook => {
        this.setState({ isUnArchiveLoadingPlaybookIds: isUnArchiveLoadingPlaybookIds.concat([playbook.id]) })
        this.unArchivePlaybook(playbook)
      }
    }
    return (actions[action] || (() => {}))(playbook)
  }

  getIsActionLoading = (playbookId, action) => {
    const {
      isCloneLoadingPlaybookIds,
      isDeleteLoadingPlaybookIds,
      isArchiveLoadingPlaybookIds,
      isUnArchiveLoadingPlaybookIds,
    } = this.state

    const actionInclusions = {
      DELETE: id => isDeleteLoadingPlaybookIds.includes(id),
      CLONE: id => isCloneLoadingPlaybookIds.includes(id),
      ARCHIVE: id => isArchiveLoadingPlaybookIds.includes(id),
      UNARCHIVE: id => isUnArchiveLoadingPlaybookIds.includes(id),
    }

    return (actionInclusions[action] || (() => {}))(playbookId)
  }

  onPageChange = (forward = true) => {
    const {
      pagination: { page }
    } = this.state
    this.updatePagination(null, page + (forward ? 1 : -1))
  }

  onPageSizeChange = option => {
    this.updatePagination(option.value, 0)
  }

  getRelevantCategoryCounts = () => {
    const {
      categoryCounts,
    } = this.state

    const {
      activeTab,
    } = this.props

    // turn { CHAT_ACTIVE: 12, EMAIL_ACTIVE: 14, CHAT_ARCHIVED: 17, ... }
    // into
    // { ACTIVE: 12, ARCHIVED: 17 }
    const relevantCounts = pickBy(categoryCounts, (here, category) => category.startsWith(activeTab))
    return mapKeys(relevantCounts, (_, category) => category.split('_')[1])
  }

  getPlaybookRow = (playbookData, index) => {
    const {
      tableState,
      sort,
      pagination,
      categoryCounts,
    } = this.state

    const {
      playbookReportTypePlans,
      orgUsers,
      showDefaultPlaybooksTooltip,
      hasDismissedOutboundPlaybookTooltip,
      orgLocale
    } = this.props

    const { playbook } = playbookData

    // If they've dismissed the default playbook tooltip, haven't dismissed this one, the playbook is an OBPB, it has the default name, and is turned off
    const canShowOutboundPlaybookTooltip = this.canShowOutboundPlaybookTooltip(playbook, showDefaultPlaybooksTooltip, hasDismissedOutboundPlaybookTooltip)

    const showInternationalWarningCopy = !!orgLocale ? orgLocale !== 'en' : false

    // TODO: revert this once the backend is up to date
    const showRowNumberNotPriority = sort.property === sortProperties.PRIORITY && tableState === tableStates.CHAT_ACTIVE

    return playbookRowFactory({
      playbookData,
      tableState: this.state.tableState,
      toggleEnablePlaybookModal: this.toggleEnablePlaybookModal,
      onDropdownActionClick: this.onDropdownActionClick,
      getIsActionLoading: this.getIsActionLoading,
      showRowNumberNotPriority,
      paginationInfo: {
        ...pagination,
        index,
        negative: sort.dir === sortDirections.DESC,
        max: categoryCounts[tableState],
      },
      orgUsers,
      playbookReportTypePlans,
      canShowOutboundPlaybookTooltip,
      dismissOutboundPlaybookTooltip: this.dismissOutboundPlaybookTooltip,
      updatePlaybookStatus: this.updatePlaybookStatus,
      showDefaultPlaybooksTooltip,
      hasDismissedOutboundPlaybookTooltip,
      showDefaultWarning: showInternationalWarningCopy,
      trackOutboundPlaybookTooltipInteraction: this.trackOutboundPlaybookTooltipInteraction
    })
  }

  renderEmptyState = () => (
    <div className="playbook-list-table-empty-state">
      <ColorWay type="3">
        <Icon name="cw-empty-search" />
      </ColorWay>
      <p>Let&#39;s get started. Create your first playbook.</p>
      {this.props.hasMarketplaceModal ? <MarketplaceModalButton buttonText="New playbook" /> :
      <Button type="primary" href={`/marketplace?tab=${this.props.activeTabLabel}`}>New Playbook</Button>}
    </div>
  )

  renderErrorState = () => (
    <div className="playbook-list-table-empty-state">
      <ColorWay type="4">
        <Icon name="cw-empty-search" />
      </ColorWay>
      <p>Oops, it looks like something went wrong - don&#39;t worry though, our team was alerted and we&#39;re on it! ⚡️</p>
      <p>This happens every now and again, usually a simple retry will do the job.</p>
      <p>
        <A onClick={this.refreshTableData}>Refresh</A>
        <span> or {
          ACCESS.hasGates('premium_drift') ?
            <A href="#table-didnt-load" onClick={newConversation}>chat with us</A>
          : 'contact your CSM for assistance'   
        }</span>
      </p>
    </div>
  )

  renderCloneFailure = () => {
    const { cloneFailurePlaybook } = this.state

    const isNewEditor = isLeadBotPlaybook(cloneFailurePlaybook.reportType)

    const goToBuilder = () => window.open(`${isNewEditor ? `/playbooks/editor/${cloneFailurePlaybook.id}/targeting/audience` : `/playbooks/${cloneFailurePlaybook.id}/edit/targeting/audience`}`, '_self')

    const onClose = () => this.setState({
      cloneFailed: false,
      cloneFailurePlaybook: null
    })

    return (
      <Modal
        type="error"
        title="Failed to clone playbook"
        size="small"
        open={true}
        className="playbook-list-clone-failed"
        onClose={onClose}
      >
        <div className="playbook-list-clone-failed--body">
          Your playbook contains missing or archived segments. Please fix these by editing your playbook
        </div>
        <footer>
          <Button type="tertiary" onClick={goToBuilder}>Edit playbook</Button>
        </footer>
      </Modal>
    )
  }

  renderArchiveWarning = () => {
    const { archiveWarningPlaybook } = this.state
    const { name } = archiveWarningPlaybook


    const onClose = () => this.setState({
      archiveWarning: false,
      archiveWarningPlaybook: null
    })

    const onArchivePlaybook = () => {
      this.archivePlaybook(archiveWarningPlaybook)
      this.setState({
        archiveWarning: false,
        archiveWarningPlaybook: null
      })
    }

    return (
      <Modal
        type="error"
        title={`${name} is used in at least one Bot Playbook`}
        size="small"
        open={true}
        className="playbook-list-disable-warning"
        onClose={onClose}
      >
        <div className="playbook-list-disable-warning--body">
          This playbook is currently being used in a bot playbook. The bot will no longer be able to enroll prospects in this email playbook. Are you sure you want to archive it?
        </div>
        <footer className="playbook-list-disable-warning-footer">
          <Button type="secondary" onClick={onArchivePlaybook}>Archive playbook</Button>
          <Button type="tertiary" onClick={onClose}>Cancel</Button>
        </footer>
      </Modal>
    )
  }

  renderDisableFailure = () => {

    const { disableWarningPlaybook, playbooks } = this.state
    const { name } = disableWarningPlaybook.playbook

    disableWarningPlaybook.playbook.status = 'ENABLED'


    const playbookIndex = playbooks.findIndex(p => p.playbook.id === disableWarningPlaybook.id)
    if (playbookIndex > -1) {
      const playbooksWithNewlyModifiedPlaybook = playbooks.slice(0, playbookIndex).concat([disableWarningPlaybook]).concat(playbooks.slice(playbookIndex + 1))
      this.setState({
        playbooks: playbooksWithNewlyModifiedPlaybook
      })
    }

    const onClose = () => this.setState({
      disableWarning: false,
      disableWarningPlaybook: null
    })

    const onDisablePlaybook = () => {
      disableWarningPlaybook.playbook.status = 'DISABLED'
      this.updatePlaybookStatus(disableWarningPlaybook.playbook)
      this.setState({
        disableWarning: false,
        disableWarningPlaybook: null
      })
    }

    return (
      <Modal
        type="error"
        title={`${name} is used in at least one Bot Playbook`}
        size="small"
        open={true}
        className="playbook-list-disable-warning"
        onClose={onClose}
      >
        <div className="playbook-list-disable-warning--body">
          This playbook is currently being used in a bot playbook. The bot will no longer be able to enroll prospects in this email playbook. Are you sure you want to disable it?
        </div>
        <footer className="playbook-list-disable-warning-footer">
          <Button type="secondary" onClick={onDisablePlaybook}>Disable playbook</Button>
          <Button type="tertiary" onClick={onClose}>Cancel</Button>
        </footer>
      </Modal>
    )
  }

  renderSalesSequenceWarning = () => {
    const { disableSalesSequencePlaybook } = this.state

    const onCloseClick = () => {
      // In order to move the toggle back to enabled, force set the status back.
      disableSalesSequencePlaybook.status = 'ENABLED'

      this.setState({
        disableSalesSequencePlaybook: null,
        disableSalesSequenceWarning: false,
      })
    }

    const onDisableClick = () => {
      // Send (bulk) unenrollment request to the backend and update the playbook status.
      // If the request errors out, set the toggle back to the enabled state.
      try {
        api.disableSalesSequenceById(disableSalesSequencePlaybook.id)
        this.updatePlaybookStatus(disableSalesSequencePlaybook)
      } catch(err) {
        disableSalesSequencePlaybook.status = 'ENABLED'
        captureException(err)
      }

      this.setState({
        disableSalesSequencePlaybook: null,
        disableSalesSequenceWarning: false,
      })
    }

    return (
      <InnerDisableSalesSequenceModal
        onCloseClick={onCloseClick}
        onDisableClick={onDisableClick}
        playbook={disableSalesSequencePlaybook}
      />
    )
  }

  dismissOutboundPlaybookTooltip = () => {
    this.props.actions.updateUserProperties({
      notify: false,
      properties: {
        "hasDismissedOutboundPlaybookTooltip": true,
      },
    })
  }

  closeDefaultPlaybookTooltip = () => {
    this.props.actions.updateUserProperties({
      notify: false,
      properties: {
        "show-default-playbooks-tooltip": false,
      },
    })
  }

  render() {
    const {
      playbooks,
      playbooksListRequestPending,
      playbooksListFetchFailed,
      selectedStatus,
      tableState,
      cloneFailed,
      disableWarning,
      archiveWarning,
      deleteWarning,
      pagination: { page, pageSize, totalPages },
      enablePlaybookModalOpen,
      enablePlaybookModalPlaybook,
      searchString,
      disableSalesSequenceWarning,
    } = this.state

    const {
      activeTab,
      showDefaultPlaybooksTooltip,
    } = this.props

    const playbooksListIsEmpty = !!playbooks && playbooks.length === 0
    const includeGABanner = activeTab === 'CHAT'

    return (
      <div>
        <EnablePlaybookModal
          open={enablePlaybookModalOpen}
          onClose={this.closeEnablePlaybookModal}
          action={() => {
            this.onPlaybookStatusChange()
            this.closeEnablePlaybookModal()
          }}
          playbook={enablePlaybookModalPlaybook.playbook}
        />

        {includeGABanner && <GoogleAnalyticsBanner/>}

        <PlaybooksTableToolbar
          selectedStatus={selectedStatus}
          searchChange={this.onSearchChange}
          searchString={searchString}
          onSelectedStatusChange={this.onSelectedStatusChange}
          categoryCounts={this.getRelevantCategoryCounts()}
          showPrioritizeButton={tableState === tableStates.CHAT_ACTIVE}
          statusOptions={PlaybookTabStatusOptions[activeTab]}
          onClickExportButton={this.openExportModal}
          pagination={{ page, pageSize, totalPages }}
          playbooksListRequestPending={playbooksListRequestPending}
          playbooks={playbooks}
          activeTab={activeTab}
        />

        <div className="playbook-list-table-container">
          <EducationTooltip
            onClose={() => this.closeDefaultPlaybookTooltip()}
            showTooltip={(!!playbooks && !!showDefaultPlaybooksTooltip && tableState === tableStates.CHAT_ACTIVE)}
            tooltipSide="top"
            tooltipCaretLocation="center"
            headerCopy="Default Templates"
            bodyCopy="We've added a few default templates to get you started. Click on a playbook to edit, customize, and turn it on!">
            <Table
              isWorking={playbooksListRequestPending}
              data={!!playbooks ? playbooks.map(this.getPlaybookRow) : []}
              columns={this.getFormattedColumns()}
              className={'playbook-list-table'}
            />
          </EducationTooltip>

          {playbooksListIsEmpty &&
            this.renderEmptyState()
          }
          {playbooksListFetchFailed &&
            this.renderErrorState()
          }
          {
            cloneFailed &&
            this.renderCloneFailure()
          }
          {
            disableWarning &&
            this.renderDisableFailure()
          }
          {
            archiveWarning &&
            this.renderArchiveWarning()
          }
          {
            deleteWarning &&
            this.renderDeleteWarning()
          }
          {
            disableSalesSequenceWarning &&
            this.renderSalesSequenceWarning()
          }
        </div>
        <Paginator
          goForward={() => this.onPageChange()}
          goBackward={() => this.onPageChange(false)}
          changeSize={this.onPageSizeChange}
          index={page}
          totalPages={totalPages}
          size={pageSize}
        />
      </div>
    )
  }
}

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({
    fetchPlaybooksByGatedPlan: PlaybookActions.fetchPlaybooksByGatedPlan,
    fetchPlaybooksByReportType: PlaybookActions.fetchPlaybooksByReportType,
    enableAllPlaybooksByReportType: PlaybookActions.enableAllPlaybooksByReportType,
    updateUserProperties,
    track: TrackingActions.track
  }, dispatch)
})

const mapStateToProps = (state, props) => ({
  orgUsers: UserSelectors.orgUsersById(state, props),
  orgId: orgId(state),
  hasDemoOrg: GateSelectors.hasDemoOrg(state),
  playbookReportTypePlans: PlaybookSelectors.getPlaybookReportTypePlansEnabled(state),
  showDefaultPlaybooksTooltip: properties(state).get('show-default-playbooks-tooltip'),
  hasDismissedOutboundPlaybookTooltip: properties(state).get('hasDismissedOutboundPlaybookTooltip'),
  onlyMine: !ACCESS.isAdmin() && !ACCESS.hasAnyScope('SALES_SEQUENCES'),
  orgLocale: orgLocale(state)
})

export default connect(mapStateToProps, mapDispatchToProps)(PlaybooksTable)



// WEBPACK FOOTER //
// ./src/scripts/components/PlaybookList/PlaybooksTableContainer/index.js